var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Grid, Stack, TableHead, Chip, IconButton, CircularProgress, Dialog, DialogTitle, DialogContent, Card, CardContent, DialogActions } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import MenuIcon from '@mui/icons-material/Menu';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ArticleIcon from '@mui/icons-material/ContactMail';
import PortraitIcon from '@mui/icons-material/Portrait';
import { buildAddressString } from './models';
import AddressBookEditor from './address-book-editor';
var AddressBookList = /** @class */ (function (_super) {
    __extends(AddressBookList, _super);
    function AddressBookList(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.state = {
            isEditorVisible: false,
            caseTypes: (_a = _this.props.addressBookStore) === null || _a === void 0 ? void 0 : _a.caseTypes
        };
        return _this;
    }
    Object.defineProperty(AddressBookList.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var items = (_b = (_a = this.props.addressBookStore) === null || _a === void 0 ? void 0 : _a.addresses) !== null && _b !== void 0 ? _b : [];
            return (_jsxs("div", __assign({ className: "address-book-root" }, { children: [_jsx(Grid, __assign({ className: "address-book-filter", container: true, direction: "row", alignItems: "left" }, { children: _jsxs(Grid, __assign({ item: true, xs: 3, container: true, direction: "row", alignItems: "left" }, { children: [_jsx(Button, __assign({ variant: "contained", startIcon: _jsx(AddCircleIcon, {}, void 0), onClick: function (e) { return _this.createNew(e); }, className: "self-align-center" }, { children: (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getLabel('AddressBook.CreateNew') }), void 0), this.renderEditorDialog(), this.renderConfirmDeleteDialog()] }), void 0) }), void 0), _jsx("div", __assign({ className: "address-book-container" }, { children: ((_d = this.props.addressBookStore) === null || _d === void 0 ? void 0 : _d.isBusy)
                            ? _jsx("div", __assign({ className: "address-book-progress" }, { children: _jsx(CircularProgress, {}, void 0) }), void 0)
                            :
                                _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(PersonIcon, {}, void 0), _jsx("span", { children: (_e = this.props.languageStore) === null || _e === void 0 ? void 0 : _e.getLabel('AddressBook.FullName') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(CorporateFareIcon, {}, void 0), _jsx("span", { children: (_f = this.props.languageStore) === null || _f === void 0 ? void 0 : _f.getLabel('AddressBook.Organization') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(550) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(ContactMailIcon, {}, void 0), _jsx("span", { children: (_g = this.props.languageStore) === null || _g === void 0 ? void 0 : _g.getLabel('AddressBook.Address') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(ArticleIcon, {}, void 0), _jsx("span", { children: (_h = this.props.languageStore) === null || _h === void 0 ? void 0 : _h.getLabel('AddressBook.CaseTypes') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(PortraitIcon, {}, void 0), _jsx("span", { children: (_j = this.props.languageStore) === null || _j === void 0 ? void 0 : _j.getLabel('AddressBook.CreatedBy') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(MenuIcon, {}, void 0), _jsx("span", { children: (_k = this.props.languageStore) === null || _k === void 0 ? void 0 : _k.getLabel('AddressBook.Actions') }, void 0)] }), void 0) }), void 0)] }, void 0) }, void 0), _jsx(TableBody, { children: (_l = items.map(function (row) { return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _this.buildUserDisplayName(row.firstName, row.lastName) }), void 0) }, void 0), _jsx(TableCell, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: row.organizationName }), void 0) }, void 0), _jsx(TableCell, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: buildAddressString(row, true) }), void 0) }, void 0), _jsx(TableCell, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _this.buildCaseTypeRows(row.caseTypeIds) }), void 0) }, void 0), _jsx(TableCell, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: row.createdByName }), void 0) }, void 0), _jsx(TableCell, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(IconButton, __assign({ color: "primary", size: "small", onClick: function () { return _this.onEditClick(row); } }, { children: row.isOwner ? _jsx(EditIcon, {}, void 0) : _jsx(RemoveRedEyeIcon, {}, void 0) }), void 0), row.isOwner && !row.hasLinkedCases
                                                                    ? _jsx(IconButton, __assign({ color: "primary", size: "small", onClick: function () { return _this.onDeleteClick(row.id); } }, { children: _jsx(DeleteIcon, {}, void 0) }), void 0)
                                                                    : null] }), void 0) }, void 0)] }, row.id)); })) !== null && _l !== void 0 ? _l : _jsx("span", { children: "No items" }, void 0) }, void 0)] }, void 0) }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(AddressBookList.prototype, "createNew", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            this.setState(__assign(__assign({}, this.state), { isEditorVisible: true, selectedItem: {
                    id: '',
                    organizationName: '',
                    firstName: '',
                    lastName: '',
                    phoneNumber: '',
                    email: '',
                    description: '',
                    addressLine1: '',
                    addressLine2: '',
                    country: '',
                    city: '',
                    postalCode: '',
                    additionalInfo: '',
                    createdByName: '',
                    createdById: '',
                    visibility: 'Owner',
                    isOwner: true,
                    hasLinkedCases: false,
                    caseTypeIds: []
                } }));
        }
    });
    Object.defineProperty(AddressBookList.prototype, "onEditClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (address) {
            this.setState(__assign(__assign({}, this.state), { isEditorVisible: true, selectedItem: address }));
        }
    });
    Object.defineProperty(AddressBookList.prototype, "onDeleteClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            this.setState(__assign(__assign({}, this.state), { deleteItemId: id }));
        }
    });
    Object.defineProperty(AddressBookList.prototype, "buildCaseTypeRows", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypes) {
            var _this = this;
            var items = caseTypes === null || caseTypes === void 0 ? void 0 : caseTypes.map(function (t, i) {
                var _a, _b, _c;
                return (_jsx(Chip, { sx: { marginRight: '10px' }, color: "primary", label: (_c = (_b = (_a = _this.props.addressBookStore) === null || _a === void 0 ? void 0 : _a.caseTypes) === null || _b === void 0 ? void 0 : _b.find(function (x) { return x.id === t; })) === null || _c === void 0 ? void 0 : _c.name }, i));
            });
            return (_jsx(Stack, __assign({ direction: "row" }, { children: items }), void 0));
        }
    });
    Object.defineProperty(AddressBookList.prototype, "renderEditorDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (!this.state.isEditorVisible || !this.state.selectedItem)
                return null;
            return (_jsx(AddressBookEditor, { addressItem: this.state.selectedItem, caseTypes: this.state.caseTypes, addressBookStore: this.props.addressBookStore, onClose: function (isOk) { return _this.onCloseEditor(isOk); } }, void 0));
        }
    });
    Object.defineProperty(AddressBookList.prototype, "onCloseEditor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isOk) {
            this.setState(__assign(__assign({}, this.state), { isEditorVisible: false }));
        }
    });
    Object.defineProperty(AddressBookList.prototype, "buildCellStyle", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (width) {
            return {
                width: width,
                maxWidth: width,
                minWidth: width,
                overflow: 'hidden'
            };
        }
    });
    Object.defineProperty(AddressBookList.prototype, "buildUserDisplayName", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (firstName, lastName) {
            var displayName = '';
            if (firstName)
                displayName = firstName;
            if (lastName) {
                if (displayName)
                    displayName += ' ';
                displayName += lastName;
            }
            if (displayName)
                return displayName;
            return '';
        }
    });
    Object.defineProperty(AddressBookList.prototype, "renderConfirmDeleteDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Dialog, __assign({ open: this.state.deleteItemId !== undefined, onClose: function () { return _this.onCloseConfirm(false); } }, { children: [_jsx(DialogTitle, { children: "Confirmation" }, void 0), _jsx(DialogContent, __assign({ sx: { minWidth: '300px' } }, { children: _jsx(Card, { children: _jsx(CardContent, { children: "Do you wish to delete this item?" }, void 0) }, void 0) }), void 0), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ variant: "contained", color: "warning", onClick: function () { return _this.onCloseConfirm(true); } }, { children: "Yes" }), void 0), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return _this.onCloseConfirm(false); } }, { children: "No" }), void 0)] }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(AddressBookList.prototype, "onCloseConfirm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isConfirmed) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.setState(__assign(__assign({}, this.state), { deleteItemId: undefined }));
                            if (!isConfirmed) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.props.addressBookStore) === null || _a === void 0 ? void 0 : _a.deleteItem(this.state.deleteItemId))];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
    });
    AddressBookList = __decorate([
        inject('languageStore'),
        inject('addressBookStore'),
        observer
    ], AddressBookList);
    return AddressBookList;
}(React.Component));
export default AddressBookList;
